import localStorage from '@/utils/localStorage';

const queryString = require('query-string')

const hbLoginPtids = [
  'h5',      'test-native', 'test-oauth', 'test-decode',
  'abc-app', 'cmb',         'enterprise', 'youcheng',
  'inspur',  'jdbtpay',     'zxh'
];

function checkNeedHbLogin(from="") {
  let ptid = localStorage.get('ptid') || from;
  return hbLoginPtids.indexOf(ptid) > -1;
}

function generateRu(targetUrl) {
  let urlSplit = targetUrl.split('?');
  let urlOrigin = urlSplit[0];
  let urlSearch = urlSplit[1];

  let parsed = urlSearch ? queryString.parse(urlSearch) : {};

  let urlPtid = parsed.ptid || '';
  let ptid = localStorage.get('ptid') || 'h5';

  let ru = "";
  if (urlPtid) {
    ru = targetUrl;
  } else {
    if (urlSearch) {
      ru = targetUrl + '&ptid=' + ptid;
    } else {
      ru = urlOrigin + '?ptid=' + ptid;
    }
  }

  return encodeURIComponent(ru);
}

function generateHbLoginUrl(targetUrl) {
  // let url = 'https://h5.133.cn/hangban/vue/login/partner?project=gaotie&ru=' + generateRu(targetUrl);
  let url = 'https://h5.133.cn/hangban/account/authorize?client_id=gtgj&response_type=token&project=gaotie&redirect_uri=' + generateRu(targetUrl);
  return url;
}

export default {
  hbLoginPtids,
  checkNeedHbLogin,
  generateRu,
  generateHbLoginUrl
}



// WEBPACK FOOTER //
// ./src/auth/hbLogin.js